import { Box, IconButton } from "@material-ui/core";
import { ChevronLeft, ChevronRight, Close } from "@material-ui/icons";
import { observer } from "mobx-react-lite";

import AnnouncementContent, { getContrastColor } from "./AnnouncementContent";
import useAnnouncements from "../../hooks/useAnnouncements";

const TopAnnouncement = observer(() => {
  const { items, current, prev, dismiss } =
    useAnnouncements("top_announcement");

  if (!current) {
    return null;
  }

  const textColor = getContrastColor(current.backgroundColor) || "inherit";

  const handleDismiss = () => {
    if (current?._id && typeof window !== "undefined") {
      dismiss(current._id);
    }
  };

  const handleNext = () => {
    handleDismiss();
  };

  return (
    <Box bgcolor={current.backgroundColor || "#FFD140"} boxShadow={3} width="100%">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        paddingX={0.5}
        paddingY={0.25}
        position="relative"
      >
        {items.length > 1 && (
          <IconButton
            onClick={prev}
            aria-label="previous announcement"
            size="small"
            style={{ color: textColor }}
          >
            <ChevronLeft />
          </IconButton>
        )}
        <Box flex={1} minWidth={0} color={textColor}>
          <AnnouncementContent announcement={current} />
        </Box>
        {items.length > 1 && (
          <IconButton
            onClick={handleNext}
            aria-label="next announcement"
            size="small"
            style={{ color: textColor }}
          >
            <ChevronRight />
          </IconButton>
        )}
        <IconButton
          onClick={handleDismiss}
          aria-label="close announcement"
          size="small"
          style={{ color: textColor, marginRight: 8 }}
        >
          <Close />
        </IconButton>
      </Box>
    </Box>
  );
});

export default TopAnnouncement;